//Library modul
import { Component } from "react";
import { connect } from "react-redux";

//Personal Component

import PaymentConfirmation from "../../Components/payment/PaymentConfirmation.jsx";
import PaymentCancellation from "../../Components/payment/PaymentCancellation.jsx";
import CheckOut from "../../Components/payment/CheckOut.jsx";
import Modal from "../../Components/common_modal/Modal.jsx";

//Redux function
import {
  getUserPaymentDetail,
  paypal_capture,
  set_value_payment,
  user_action_qris,
} from "../../App/actions/paymentActions.js";
import { cancelWaitPurchase } from "../../App/actions/blogAction.js";

//Picture Asset
import IconCheck from "../../Components/common_icon/IconCheck.jsx";
import IconCancel from "../../Components/common_icon/IconCancel.jsx";
import logo_mandiri from "../../Assets/png_jpg/logo_mandiri.png";
import qris from "../../Assets/png_jpg/qris.png";
import qris_info from "../../Assets/png_jpg/qris_info.png";

//General Function
import isEqual from "../../App/validation/is-equal.js";
import dict from "../../Data/dict.json";
import history from "../../App/actions/history.js";
import { snackbar } from "../../App/actions/snackbarActions.js";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { convert_to_currency_with_unit } from "../../App/validation/convert_to_currency_with_unit.js";
import { verify_license } from "../../App/actions/license_actions.js";
import { set_value_user } from "../../App/actions/authActions.js";
import { set_value_properties } from "../../App/actions/propertiesActions.js";

const paypal_client_id_sandbox = process.env.REACT_APP_PAYPAL_CLIENT_ID_SANDBOX;
const paypal_client_id_production = process.env.REACT_APP_PAYPAL_CLIENT_ID;

class PaymentInstruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalConfirm: false,
      modalCancel: false,
      modalCancelDataExchange: false,
      rekeningCopied: false,
      amountCopied: false,
      modalCheckOut: false,
    };
  }

  componentDidMount = async () => {
    if (this.props.match?.params?.payment_id) {
      const { payment_id } = this.props.match.params;
      this.props.getUserPaymentDetail(payment_id);
    } else if (this.props.payment_id) {
      const { payment_id } = this.props;
      this.props.getUserPaymentDetail(payment_id);
    }

    // const payment = localStorage.getItem("payment");
    // if (payment) {
    //   await this.props.getUserPaymentDetail(this.props.payment_id);
    //   await this.toogleMidtrans();
    // }
  };

  componentDidUpdate(prevProps) {
    const { modalConfirm, modalCheckOut } = this.state;
    if (!isEqual(this.props.payment.payment, prevProps.payment.payment)) {
      if (modalConfirm) {
        this.toggleConfirm();
      }
      if (modalCheckOut) {
        this.toggleCheckOut();
      }
    }
  }

  on_user_action_qris = () => {
    const { payment_id } = this.props.match.params;
    const body = { payment_id };
    this.props.user_action_qris(body);
  };

  handleCancelDataExchange = (action) => {
    const { payment } = this.props.payment;
    const payment_id = payment._id;
    const body = { payment_id, action };
    this.props.cancelWaitPurchase(body);
  };

  handleCopyToClipBoard = (text, type) => {
    navigator.clipboard.writeText(text);
    this.setState({
      [type]: true,
    });
    setTimeout(
      function () {
        this.setState({ [type]: false });
      }.bind(this),
      500,
    );
  };

  toggleConfirm = () => {
    this.setState({ modalConfirm: !this.state.modalConfirm });
  };

  toggleCancel = () => {
    this.setState({ modalCancel: !this.state.modalCancel });
  };

  toggleCancelDataExchange = () => {
    this.setState({
      modalCancelDataExchange: !this.state.modalCancelDataExchange,
    });
  };

  toggleCheckOut = () => {
    this.setState({ modalCheckOut: !this.state.modalCheckOut });
  };

  verify_licenses = () => {
    this.props.verify_license("license_basic");
    this.props.verify_license("license_sini_ai");
    this.props.verify_license("license_sini_data");
  };

  toogleMidtrans = () => {
    const { payment } = this.props.payment;

    window.snap.pay(payment.midtrans.token, {
      onSuccess: (result) => {
        /* You may add your own implementation here */
        this.props.snackbar({
          is_open: true,
          status: "success",
          message: "Payment success",
          duration: 10000,
        });

        this.props.verify_license("license_basic");
        this.props.verify_license("license_sini_ai");
        this.props.verify_license("license_sini_data");

        if (this.props.is_redirect) {
          history.push("/user_profile");
        }

        this.props.set_value_payment({
          key: "payment",
          value: {
            ...payment,
            status: "success",
          },
        });

        this.props.set_value_payment({
          key: "is_able_to_greeting_page",
          value: true,
        });

        // this.props.set_value_user("modal_payment_universal", false);
      },
      onPending: (result) => {
        /* You may add your own implementation here */
        // alert("wating your payment!");
        history.push("/user_profile?tab=list_payment");
      },
      onError: (result) => {
        /* You may add your own implementation here */
        // alert("payment failed!");
        this.props.snackbar({
          is_open: true,
          status: "error",
          message: "Payment Failed",
        });
        history.push("/user_profile?tab=list_payment");
      },
      onClose: () => {
        /* You may add your own implementation here */
        // history.push("/purchase_list");
        const paramPayment = localStorage.getItem("payment");
        if (paramPayment) {
          localStorage.removeItem("payment");
        }
      },
    });
  };

  onPayment = async () => {
    const paypal_order_id =
      this.props.payment?.payment?.paypal?.paypal_order_id;
    if (!paypal_order_id) throw new Error("Missing PayPal order ID");
    return paypal_order_id;
  };

  onApprove = async (data) => {
    const { payment } = this.props.payment;
    const payment_id = payment._id;
    const body = {
      orderId: data.orderID,
      payment_id,
      is_sandbox: payment?.is_sandbox,
    };
    await this.props.paypal_capture(body);

    if (this.props.is_redirect) {
      history.push("/user_profile");
    }

    this.props.set_value_payment({
      key: "payment",
      value: {
        ...payment,
        status: "success",
      },
    });

    this.props.set_value_payment({
      key: "is_able_to_greeting_page",
      value: true,
    });
  };

  onError = async (error) => {
    console.log(error);
    // const rawId = this.props.payment?.payment?.paypal?.paypal_order_id;

    // try {
    //   const res = await axios.post("/api/paypal/check_order_status", {
    //     orderId: rawId
    //   });

    //   const status = res.data?.status;

    //   let message = "Terjadi kesalahan saat memproses pembayaran.";

    //   if (res.data?.notFound) {
    //     message = "Order tidak ditemukan. Mungkin sudah kadaluarsa atau ID tidak valid.";
    //   } else if (status !== "CREATED") {
    //     message = `Order tidak bisa digunakan karena statusnya: ${status}.`;
    //   }
    //   this.setState({ error_message: message });
    // } catch (e) {
    //   this.setState({ error_message: "Gagal memverifikasi status order." });
    // }
  };

  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";

    const {
      modalConfirm,
      modalCancel,
      rekeningCopied,
      amountCopied,
      modalCheckOut,
      modalCancelDataExchange,
    } = this.state;

    const { payment } = this.props.payment || {};

    const {
      status,
      payment_type,
      payment_methode,
      currency = "IDR",
      detail_amount,
      items = [],
      is_sandbox,
      collaborator_qty,
    } = payment || {};
    const month_license = items?.[0]?.currency_price?.duration?.month;

    const initial_options = {
      clientId: is_sandbox
        ? paypal_client_id_sandbox
        : paypal_client_id_production,
    };

    const price = detail_amount?.price || payment?.price;
    const amount = detail_amount?.total || payment?.amount || 0;
    const add_tax = detail_amount?.tax || (price * 11) / 100;
    const discount = detail_amount?.discount || 0;

    const converted_price_currency = convert_to_currency_with_unit({
      currency,
      value: price,
    });
    const converted_tax_currency = convert_to_currency_with_unit({
      currency,
      value: add_tax,
    });
    const converted_discount_currency = convert_to_currency_with_unit({
      currency,
      value: discount,
    });
    const converted_amount_currency = convert_to_currency_with_unit({
      currency,
      value: amount,
    });

    let header_text;
    let button_content;
    let footer_content;
    let item_content;

    const accepted_licenses = [
      "license_1",
      "license_2",
      "license_3",
      "data_exchange",
      "personal",
      "team",
      "enterprise",
    ];

    if (accepted_licenses.includes(payment_type)) {
      if (status === "wait_purchase") {
        header_text = dict["Complete your payment"][language];
        button_content = (
          <main style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              onClick={this.toggleConfirm}
              className="button background_black"
            >
              {dict["Upload Payment Receipt"][language]}
            </button>
            <br />
            {payment_type === "data_exchange" ? (
              <button
                onClick={this.toggleCancelDataExchange}
                style={{ marginTop: "40px" }}
                className="text_danger"
              >
                {dict["Cancel Transaction"][language]}
              </button>
            ) : (
              <button
                onClick={this.toggleCancel}
                style={{ marginTop: "40px" }}
                className="text_danger"
              >
                {dict["Cancel Transaction"][language]}
              </button>
            )}
          </main>
        );
        footer_content = (
          <div>
            <div>{dict["Payment method"][language]}</div>
            <hr />
            <div style={{ marginBottom: "5px" }}>
              •{" "}
              {
                dict[
                  "Make sure your payment has been SUCCESSFUL and upload proof of payment immediately."
                ][language]
              }
            </div>
            <div style={{ marginBottom: "5px" }}>
              •{" "}
              {
                dict[
                  "The license will be active after you upload proof of payment."
                ][language]
              }
            </div>
            <div style={{ marginBottom: "5px" }}>
              •{" "}
              {
                dict[
                  "Checking will be done manually, if we don't receive payment, your license will be cancelled."
                ][language]
              }
            </div>
          </div>
        );
      } else if (status === "user_purchase") {
        header_text =
          dict?.["Proof of payment has been uploaded successfully."]?.[
            language
          ];
        if (payment_methode === "qris") {
          header_text = dict?.["Payment has been made with QRIS"]?.[language];
        }
        if (payment_type === "license_1") {
          header_text =
            dict["You have successfully uploaded your KTM."][language];
        }
        button_content = (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <IconCheck height="100px" />
          </div>
        );
        if (payment_type === "license_1") {
          button_content = (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <IconCheck height="100px" />
              <section style={{ marginTop: "10px" }}>
                <img
                  alt="ktm"
                  src={payment?.picture_url}
                  style={{ width: "300px", maxWidth: "100%" }}
                />
              </section>
            </div>
          );
        }
        footer_content = (
          <div>
            <p>{dict["Information"][language]}</p>
            <hr />
            <p>
              {
                dict[
                  "The proof of payment has been uploaded successfully, while our team checks the payment, you can already use the GEO MAPID license."
                ][language]
              }
            </p>
          </div>
        );
        if (payment_type === "license_1") {
          footer_content = (
            <div>
              <p>{dict["Information"][language]}</p>
              <hr />
              <p>
                {
                  dict?.[
                    "Your KTM has been uploaded successfully, while our team checks the correctness of your student status, you can already use the GEO MAPID license."
                  ]?.[language]
                }
              </p>
            </div>
          );
        }
        if (payment_type === "data_exchange") {
          footer_content = (
            <div>
              <p>{dict["Information"][language]}</p>
              <hr />
              <p>
                {
                  dict[
                    "Proof of payment has been successfully uploaded, we will check your funds and we will forward it to the seller."
                  ][language]
                }
              </p>
            </div>
          );
        }
      } else if (status === "user_cancel") {
        header_text = dict["Your payment has been cancelled."][language];
        button_content = (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <IconCancel height="100px" />
          </div>
        );
        footer_content = (
          <div>
            <p>{dict["Information"][language]}</p>
            <hr />
            <p>{dict["You have canceled this transaction."][language]}</p>
          </div>
        );
      } else if (status === "success") {
        header_text = dict["We have received payment."][language];
        button_content = (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <IconCheck height="100px" />
          </div>
        );
        footer_content = (
          <div>
            <p>{dict["Information"][language]}</p>
            <hr />
            <p>
              {
                dict[
                  "We have confirmed the payment, the overpayment as a unique code has been returned as MAPID Balance."
                ][language]
              }
            </p>
          </div>
        );
      } else if (status === "rejected") {
        header_text = dict["We didn't find the payment."][language];
        button_content = (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              onClick={this.toggleConfirm}
              className="button background_black"
              style={{ marginBottom: "20px" }}
            >
              {dict["Upload Payment Receipt Again"][language]}
            </button>
            <br />
            <IconCancel height="100px" />
          </div>
        );
        footer_content = (
          <div>
            <p>{dict["Information"][language]}</p>
            <hr />
            <p>
              {
                dict[
                  "We did not find the payment with the proof of payment that you uploaded."
                ][language]
              }
            </p>
          </div>
        );
      }

      let payment_type_content;
      switch (payment_type) {
        case "license_1":
          payment_type_content = "PERSONAL";
          break;
        case "license_2":
          payment_type_content = "BUSINESS";
          break;
        case "license_3":
          payment_type_content = "ENTERPRISE";
          break;
        case "data_exchange":
          payment_type_content = dict["Payment data exchange"][language];
          break;
        default:
          if (["personal", "team", "enterprise"].includes(payment_type)) {
            payment_type_content = payment_type?.toUpperCase();
          } else {
            payment_type_content = dict["Others"][language];
          }
          break;
      }
      const headerContent = (
        <main
          className="container_standard"
          id="white"
          style={{
            width: "600px",
            maxWidth: "calc(( 100% - 20px ))",
            margin: "auto",
            marginBottom: "30px",
          }}
        >
          {is_sandbox && (
            <section
              style={{
                padding: "5px 0 5px 0",
                backgroundColor: "orange",
                display: "flex",
                justifyContent: "center",
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              Sandbox mode
            </section>
          )}
          <section style={{ marginBottom: "5px" }}>{header_text}</section>
          <hr />
          <section>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <div
                style={{
                  textAlign: "right",
                  fontWeight: "bolder",
                  marginTop: "10px",
                }}
              >
                {payment_type_content}
                {payment_type === "team" &&
                  ` (1 master, ${collaborator_qty - 1} ${collaborator_qty - 1 > 1 ? "members" : "member"})`}
              </div>

              <div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ display: "flex", gap: "5px" }}>
                    {items?.length > 0 && (
                      <label>
                        {items
                          .map((item) => item?.name || item?.key)
                          ?.join(" + ")}
                      </label>
                    )}
                  </div>
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                  >
                    {converted_price_currency}
                  </label>
                </div>
                {month_license && (
                  <div>{`${month_license} ${
                    month_license > 1 ? "months" : "month"
                  }`}</div>
                )}
              </div>
              <hr />

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label>Subtotal</label>
                <label
                  style={{
                    fontSize: "20px",
                    color: "black",
                  }}
                >
                  {converted_price_currency}
                </label>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label>Tax ({items?.[0]?.currency_price?.tax || 11}%)</label>
                <label
                  style={{
                    fontSize: "20px",
                    color: "black",
                  }}
                >
                  {converted_tax_currency}
                </label>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label>Discount</label>
                <label
                  style={{
                    fontSize: "20px",
                    color: "black",
                  }}
                >
                  {converted_discount_currency}
                </label>
              </div>
              <hr style={{ borderTop: "1px solid #ccc", margin: "10px 0" }} />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label style={{ fontWeight: "bold" }}>
                  {dict["Total price"][language]}
                </label>
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    color: "#003366",
                  }}
                >
                  {converted_amount_currency}
                </label>
              </div>
            </div>
          </section>
        </main>
      );
      let box_transfer_info = <div></div>;
      if (["wait_purchase", "rejected"].includes(status)) {
        box_transfer_info = (
          <main>
            <main
              className="container_standard"
              id="white"
              style={{
                width: "600px",
                maxWidth: "calc(( 100% - 20px ))",
                margin: "auto",
              }}
            >
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                {dict?.["Payment method"]?.[language]} 1 : QRIS
              </div>
              <hr />
              <section className="text_center">
                <img
                  src={qris_info}
                  alt="qris_info"
                  style={{ width: "70%", marginBottom: "10px" }}
                />
                <br />
                <img
                  src={qris}
                  alt="qris"
                  style={{
                    width: "350px",
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                />
                <p className="text_bold">MAPID</p>
                <p className="text_bold">ID2022174374084</p>
              </section>

              <section
                className="two_container_equal"
                style={{ marginTop: "30px" }}
              >
                <div>
                  <p>{dict["Total price"][language]}</p>
                  <p className="text_header">{converted_amount_currency}</p>
                  {amountCopied && (
                    <p
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#000",
                        display: "inline-block",
                      }}
                    >
                      {dict["Copied"][language]}
                    </p>
                  )}
                  <div
                    className="arrow_up"
                    style={{ marginLeft: "60px" }}
                  ></div>
                  <div className="badge_normal">
                    {
                      dict[
                        "Important! Transfers exactly to the last 3 digits."
                      ][language]
                    }
                  </div>
                </div>
                <div
                  onClick={this.handleCopyToClipBoard.bind(
                    this,
                    payment.amount,
                    "amountCopied",
                  )}
                  className="text_medium"
                  style={{
                    textAlign: "right",
                    marginTop: "auto",
                    marginBottom: "auto",
                    cursor: "pointer",
                  }}
                >
                  {dict["Copy"][language]}
                </div>
              </section>
              <section className="text_center" style={{ marginTop: "10px" }}>
                <button
                  className="button background_black"
                  onClick={this.on_user_action_qris}
                >
                  Klik di sini jika sudah scan & bayar
                </button>
              </section>
            </main>
            <br />
            <br />
            <br />
            <main
              className="container_standard"
              id="white"
              style={{
                width: "600px",
                maxWidth: "calc(( 100% - 20px ))",
                margin: "auto",
              }}
            >
              <section className="two_container_equal">
                <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                  {dict?.["Payment method"]?.[language]} 2 :{" "}
                  {dict?.["Bank transfer"]?.[language]}
                </div>
                <div style={{ textAlign: "right" }}>
                  <img src={logo_mandiri} height="25px" alt="logo_mandiri" />
                </div>
              </section>
              <hr />
              <section className="two_container_equal">
                <div>
                  <p>{dict["Account number"][language]}</p>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#0575e6",
                      display: "inline-block",
                    }}
                  >
                    130 008 877 8785 (Mandiri)
                  </p>
                  {rekeningCopied && (
                    <p
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#000",
                        display: "inline-block",
                      }}
                    >
                      {dict["Copied"][language]}
                    </p>
                  )}
                  <p>{dict["Account name"][language]}</p>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#0575e6",
                      display: "inline-block",
                    }}
                  >
                    PT Multi Areal Planing Indonesia
                  </p>
                </div>
                <button
                  onClick={this.handleCopyToClipBoard.bind(
                    this,
                    "1300088778785",
                    "rekeningCopied",
                  )}
                  className="text_medium"
                  style={{
                    textAlign: "right",
                    marginTop: "auto",
                    marginBottom: "auto",
                    cursor: "pointer",
                  }}
                >
                  {dict["Copy"][language]}
                </button>
              </section>
              <section
                className="two_container_equal"
                style={{ marginTop: "30px" }}
              >
                <div>
                  <p>{dict["Total price"][language]}</p>
                  <p className="text_header">{converted_amount_currency}</p>
                  {amountCopied && (
                    <p
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#000",
                        display: "inline-block",
                      }}
                    >
                      {dict["Copied"][language]}
                    </p>
                  )}
                  <div
                    className="arrow_up"
                    style={{ marginLeft: "60px" }}
                  ></div>
                  <div className="badge_normal">
                    {
                      dict[
                        "Important! Transfers exactly to the last 3 digits."
                      ][language]
                    }
                  </div>
                </div>
                <div
                  onClick={this.handleCopyToClipBoard.bind(
                    this,
                    payment.amount,
                    "amountCopied",
                  )}
                  className="text_medium"
                  style={{
                    textAlign: "right",
                    marginTop: "auto",
                    marginBottom: "auto",
                    cursor: "pointer",
                  }}
                >
                  {dict["Copy"][language]}
                </div>
              </section>
              {button_content}
              <section
                style={{
                  width: "600px",
                  maxWidth: "calc(( 100% - 20px ))",
                  margin: "auto",
                  marginTop: "40px",
                }}
              >
                {footer_content}
              </section>
            </main>
          </main>
        );
      } else {
        box_transfer_info = <main>{button_content}</main>;
      }
      let payment_button;
      if (["wait_purchase", "rejected"].includes(status)) {
        if (payment_methode === "paypal") {
          payment_button = (
            <section
              className="container_standard"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <PayPalScriptProvider options={initial_options}>
                <div className="paypal-wrapper">
                  <PayPalButtons
                    style={{
                      shape: "rect",
                      layout: "vertical",
                      label: "pay",
                    }}
                    createOrder={this.onPayment}
                    onApprove={this.onApprove}
                    onError={this.onError}
                    // fundingSource="paypal"
                  />
                </div>
              </PayPalScriptProvider>
            </section>
          );
        } else {
          payment_button = (
            <section
              className="container_standard"
              style={{ textAlign: "center" }}
            >
              <button
                className="button_big background_black"
                onClick={this.toogleMidtrans}
              >
                {dict["Pay Now"][language]}
              </button>
            </section>
          );
        }
      } else {
        payment_button = <main>{button_content}</main>;
      }

      item_content = (
        <main>
          <section>
            {headerContent}
            <div style={{ display: "none" }}>{box_transfer_info}</div>
            {payment_button}
          </section>
        </main>
      );
    } else {
      item_content = (
        <main>
          <h3>
            {
              dict["This page is only for license payments and data exchange"][
                language
              ]
            }
          </h3>
        </main>
      );
    }
    const modalConfirmContent = modalConfirm && (
      <Modal
        modalSize="small"
        id="modal_confirmation"
        isOpen={modalConfirm}
        onClose={this.toggleConfirm}
      >
        <div className="box-body" style={{ textAlign: "center" }}>
          <PaymentConfirmation />
        </div>
      </Modal>
    );
    const modalCancelContent = modalCancel && (
      <Modal
        modalSize="small"
        id="modal_confirmation"
        isOpen={modalCancel}
        onClose={this.toggleCancel}
      >
        <div className="box-body" style={{ textAlign: "center" }}>
          <PaymentCancellation />
        </div>
      </Modal>
    );
    const modalCheckOutContent = modalCheckOut && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modalCheckOut}
        onClose={this.toggleCheckOut}
      >
        <div className="box-body">
          <CheckOut />
        </div>
      </Modal>
    );
    const modalCancelDataExchangeContent = modalCancelDataExchange && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modalCancelDataExchange}
        onClose={this.toggleCancelDataExchange}
      >
        <div className="box-body" style={{ textAlign: "center" }}>
          <button
            onClick={this.handleCancelDataExchange.bind(this, "move_to_cart")}
            className="button background_black"
            id="green"
          >
            {dict["Move to cart"][language]}
          </button>
          <p style={{ marginTop: "10px", marginBottom: "10px" }}>
            {dict["Or"][language]}
          </p>
          <button
            onClick={this.handleCancelDataExchange.bind(this, "delete")}
            className="button background_black"
            id="grey_light"
          >
            {dict["Delete"][language]}
          </button>
        </div>
      </Modal>
    );
    return (
      <main>
        {item_content}
        {modalConfirmContent}
        {modalCancelContent}
        {modalCheckOutContent}
        {modalCancelDataExchangeContent}
      </main>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
});
export default connect(mapStateToProps, {
  getUserPaymentDetail,
  cancelWaitPurchase,
  user_action_qris,
  snackbar,
  paypal_capture,
  verify_license,
  set_value_user,
  set_value_properties,
  set_value_payment,
})(PaymentInstruction);
